import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "addOrgModal",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-700px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h2", null, "Байгууллага нэмэх", -1)
const _hoisted_6 = { class: "svg-icon svg-icon-1" }
const _hoisted_7 = { class: "modal-body" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "separator my-1" }, null, -1)
const _hoisted_9 = {
  class: "row",
  style: {"padding":"10px 20px 10px 10px"}
}
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Хадгалах ")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Болих ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_row = _resolveComponent("el-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", {
            class: "btn btn-sm btn-icon btn-active-color-primary",
            "data-bs-dismiss": "modal",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.clearField && _ctx.clearField(...args)))
          }, [
            _createElementVNode("span", _hoisted_6, [
              _createVNode(_component_inline_svg, { src: "/web/media/icons/duotone/Navigation/Close.svg" })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_el_form, {
            model: _ctx.modalForm,
            ref: "addorgmodalref",
            "label-width": "220px",
            size: "mini",
            rules: _ctx.loginFormRules
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, {
                label: "Байгууллагын код:",
                prop: "orgcode",
                "label-width": ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.modalForm.orgcode,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.modalForm.orgcode) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "Байгууллагын нэр:",
                prop: "orgname",
                "label-width": ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.modalForm.orgname,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.modalForm.orgname) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "Төрөл:",
                "label-width": ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    size: "mini",
                    modelValue: _ctx.modalForm.selectVal,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.modalForm.selectVal) = $event)),
                    style: {"width":"100%"}
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.modalForm.selectOrgType, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.selectVal,
                          label: item.selectLabel,
                          value: item.selectVal
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "Гэрээний төлөв:",
                "label-width": ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    size: "mini",
                    modelValue: _ctx.modalForm.selectStatVal,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.modalForm.selectStatVal) = $event)),
                    style: {"width":"100%"}
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.modalForm.selectOrgStat, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.selectStatVal,
                          label: item.selectStatLabel,
                          value: item.selectStatVal
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "Гэрээ эхэлсэн өдөр:",
                prop: "cstartdate",
                "label-width": ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_date_picker, {
                    modelValue: _ctx.modalForm.cstartdate,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.modalForm.cstartdate) = $event)),
                    type: "date"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "Гэрээ дуусах өдөр:",
                prop: "cenddate",
                "label-width": ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_date_picker, {
                    modelValue: _ctx.modalForm.cenddate,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.modalForm.cenddate) = $event)),
                    type: "date"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "Тайлбар:",
                "label-width": ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.modalForm.desc,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.modalForm.desc) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model", "rules"])
        ]),
        _hoisted_8,
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_el_row, {
            type: "flex",
            justify: "end"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_button, {
                type: "success",
                plain: "",
                size: "mini",
                class: "col-lg-3",
                loading: _ctx.orgaddbuttonloader,
                onClick: _cache[8] || (_cache[8] = ($event: any) => {
                _ctx.saveOrg();
                _ctx.formSubmit();
              })
              }, {
                default: _withCtx(() => [
                  _hoisted_10
                ]),
                _: 1
              }, 8, ["loading"]),
              _createVNode(_component_el_button, {
                type: "info",
                plain: "",
                size: "mini",
                class: "col-lg-3",
                ref: "hidemodalbutton",
                "data-bs-dismiss": "modal",
                onClick: _ctx.clearField
              }, {
                default: _withCtx(() => [
                  _hoisted_11
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}